import template from './jga-revocation-link-hint.html.twig';
import './jga-revocation-link-hint.scss';

const { Component, Mixin } = Shopware;

Component.register('jga-revocation-link-hint', {
    template,

    mixins: [Mixin.getByName('notification')],

    props: {
        // Plugin config wrapper passes a value prop even though we don't store anything;
        // declare it to avoid Vue prop warnings.
        value: {
            type: [String, Number, Boolean, Object, Array],
            required: false,
            default: null,
        },
    },

    computed: {
        revocationUrl() {
            return `${window.location.origin}/revocation`;
        },
    },

    methods: {
        async copyUrl() {
            try {
                await navigator.clipboard.writeText(this.revocationUrl);
                this.createNotificationSuccess({
                    message: this.$tc('jga-revocation.linkHint.copied'),
                });
            } catch (e) {
                this.createNotificationError({
                    message: this.$tc('jga-revocation.linkHint.copyFailed'),
                });
            }
        },
    },
});
